import { call, put } from 'redux-saga/effects'

import config from '../../../config'
import { UpdateProductInputInterface } from '../../../interfaces/product'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import {
  getCompanyProductListSucceed,
  requestFailure,
  updateProductSucceed
} from '../actions'

export function* updateProductSaga(
  productApi: {
    updateProduct: (...args: any[]) => any
    getCompanyProductList: (...args: any[]) => any
  },
  {
    payload: { productId, productDetail }
  }: {
    payload: {
      productId: string
      productDetail: UpdateProductInputInterface
    }
  }
) {
  try {
    const { data: updatedCompanyProduct } = yield call(
      productApi.updateProduct,
      productId,
      productDetail
    )
    yield put(updateProductSucceed())
    const { data } = yield call(
      productApi.getCompanyProductList,
      updatedCompanyProduct.companyId,
      1,
      config.product.limit,
      'createdTime',
      'desc',
      false
    )
    yield put(getCompanyProductListSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
